define('gumbo-js-client-lib/forms/gameData/WeatherForm',{
	condition: null,
	temp: null,
	wind: null
});
